import { __assign, __read, __rest, __spread } from "tslib";
import { convertDate } from '@keen.io/time-utils';
import { KEEN_TABLE_INTERVAL } from '../../../constants';
import { fillWithEmptyKeys } from '../../../utils';
export var tableChartTransformation = function (_a, parserSettings) {
    var query = _a.query, result = _a.result;
    var data = [];
    var keys = new Set();
    var fillEmptyIntervalsKeys = parserSettings.fillEmptyIntervalsKeys, dateModifier = parserSettings.dateModifier;
    result.forEach(function (interval) {
        var _a = interval, timeframe = _a.timeframe, value = _a.value;
        var intervalData = {};
        var intervalKeys = new Set();
        var tableValue = (query === null || query === void 0 ? void 0 : query.analysis_type) + "." + (query === null || query === void 0 ? void 0 : query.event_collection);
        value.forEach(function (_a) {
            var _b;
            var result = _a.result, record = __rest(_a, ["result"]);
            Object.keys(record).forEach(function (name) {
                intervalKeys.add(name);
                intervalData[name] = record[name];
                intervalData[tableValue] = result;
            });
            data.push(__assign((_b = {}, _b[KEEN_TABLE_INTERVAL] = convertDate(timeframe.start, dateModifier), _b), intervalData));
        });
        intervalKeys.forEach(function (key) { return keys.add("" + key); });
    });
    if (fillEmptyIntervalsKeys) {
        data = fillWithEmptyKeys(__spread(keys), data, 0);
    }
    return {
        data: data,
        keys: __spread(keys),
    };
};
